import { render, staticRenderFns } from "./add-dealer.vue?vue&type=template&id=9c1ce180&scoped=true"
import script from "./add-dealer.vue?vue&type=script&lang=js"
export * from "./add-dealer.vue?vue&type=script&lang=js"
import style0 from "./add-dealer.vue?vue&type=style&index=0&id=9c1ce180&prod&scoped=true&lang=scss"
import style1 from "./add-dealer.vue?vue&type=style&index=1&id=9c1ce180&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1ce180",
  null
  
)

export default component.exports